var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M30,23.75V8.25A6.25,6.25,0,0,0,23.75,2H8.25A6.25,6.25,0,0,0,2,8.25v15.5A6.25,6.25,0,0,0,8.25,30h15.5A6.25,6.25,0,0,0,30,23.75ZM5.188,15.264a1,1,0,0,1-.707-1.707l4.1-4.1A1,1,0,0,1,10,10.867l-2.4,2.4H26.813a1,1,0,0,1,0,2H5.188ZM22,22.547a1,1,0,0,1,0-1.414l2.4-2.4H5.188a1,1,0,0,1,0-2H26.813a1,1,0,0,1,.707,1.707l-4.1,4.1a1,1,0,0,1-1.42.007Z",
    fill: "#fbdddd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionEmptyIcon);
export default __webpack_public_path__ + "static/media/transaction_empty_icon.d3e8f6f709db53efd1d5b755d0cc1add.svg";
export { ForwardRef as ReactComponent };